<template>
    <div id="index">
        <div id="containerBox">
            <div id="header1">
                <div>
                    {{now1}}
                </div>
            </div>

            <div id="leftPart">
                <div id="content1">
                    <router-link to="/"><img src='/images/web_img/TOG_Logo_500X70_3.jpg' alt=""></router-link>
                    <img src='/images/web_img/book.gif' alt="">
                </div>

                <div id="content2">
                    <ul>
                        <li><router-link to="/renjiadao">Renjia Road</router-link></li>
                        <li><router-link to="/video">Share video</router-link></li>
                        <li><a href="/xuezhe.asp" target="_blank" rel="noopener noreferrer">Study rules</a></li>
                        <li><router-link to="/useraddnew">Your sharing</router-link></li>
                        <li><a href="http://www.bolaaw.com/" target="_blank" rel="noopener noreferrer">About Us</a></li>
                    </ul>
                </div>


                <div style="width:940px;height:auto;padding:20px 20px 0px 20px;">
                    <video :src="videourl"  controls="true" controlslist="nodownload" width="960" v-if="videourl"></video>
                </div>


                <div id="content7">
                    <img src='/images/web_img/footer1.jpg' alt="">

                    <pageFooter></pageFooter>
                </div>
            </div>

            <div id="rightPart">

                <img src='/images/web_img/party-lg.jpg' alt="">
                <img src='/images/web_img/in-the-future.jpg' alt="">
                
                <img src='/images/web_img/elephant-lg.jpg' alt="">
            </div>
        </div>
    </div>
</template>

<!-- <script src="http://www.templeofgood.com/TJ/sjmp5_LLFenxi.js" type="text/javascript" ></script> -->
<script>
import pageFooter from "@/components/Footer";
import clock from "@/mixins/clock";
import { request } from "@/api/http";

export default {
    components:{
        pageFooter,
    },

    mixins: [clock],

    data(){
        return{
            videourl: '',
        }
    },

    mounted(){
        this.getvideo();
    },
    methods: {
        getvideo(){
            request('/CalawaEnServlet/VideoServlet', { action: 'getPlayVideo' })
            .then(res=> {
                this.videourl = this.$store.state.WebURL + res.data.video;
            })
            .catch(error=> {
                console.log(error);
            });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin manyLine6{
    overflow: hidden;  
    text-overflow: ellipsis;  
    display: -webkit-box;  
    -webkit-line-clamp: 6;  
    -webkit-box-orient: vertical;  
}

@mixin manyLine5{
    overflow: hidden;  
    text-overflow: ellipsis;  
    display: -webkit-box;  
    -webkit-line-clamp: 5;  
    -webkit-box-orient: vertical;  
}

@mixin manyLine4{
    overflow: hidden;  
    text-overflow: ellipsis;  
    display: -webkit-box;  
    -webkit-line-clamp: 4;  
    -webkit-box-orient: vertical;  
}

@mixin manyLine3{
    overflow: hidden;  
    text-overflow: ellipsis;  
    display: -webkit-box;  
    -webkit-line-clamp: 3;  
    -webkit-box-orient: vertical;  
}

#index{
    width: 100%;
    min-height: 1490px;
    height: 100%;

    a { text-decoration:none; }
    a:hover { text-decoration:none; cursor: pointer;}

    background-color: white;

    #containerBox{
        width: 1260px;
        min-height: 1490px;
        height:100%;
        
        background-color: #ccc;

        margin: 0 auto 0 auto;

        #header1{
            width: 1212px;
            height: 15px;

            padding:15px 11px 15px 11px;

            div{ float: left; }
        }

        #leftPart{
            width: 1000px;
            // height: 970px;

            float:left;
            margin: 0 6px 0 11px;
            // background-color: aqua;
            background-color: white;

            #content1{
                height: 71px;
                background-color: white;
                img{
                    float: left;
                }
            }

            #content2{
                width: 1000px;
                height: 43px;

                margin-top: 10px;
                ul{
                    width: 1000px;
                    height: 43px;     
                    li{
                        width: 200px;
                        height: 43px;

                        float: left;

                        a{
                            width: 200px;
                            height: 33px;
                            display: inline-block;

                            background: url(../../assets/leftpart/content2/hongse.jpg) no-repeat center;
                            background-size: 200px 43px;
                            color: white;

                            padding-top: 10px;
                        }
                    }               
                }
            }

            #content3{
                img{
                    margin-top: 10px;
                }
            }

            #content5{

                img{
                    margin: 10px 0 10px 0;
                }
            }

            #content7{
                width: 1000px;
                img{
                    width: 1000px;
                    margin-top: 10px;
                }
            }
        }

        #rightPart{
            width: 230px;
            height: 1200px;

            float:left;

            background-color: white;

            img{
                width:220px;
                margin-top: 10px;
            }
            .fenxiang{
                width:220px;
                margin-top: -40px;
            }

            .contactus{
                width: 220px;
                height: 300px;
                margin-left: 5px;
                img:nth-child(1){
                    width: 220px;
                }
                p{
                    text-align: left;
                    font-size: 13px;
                    margin: 10px 10px 0 10px;
                }
                img:nth-child(7){
                    width: 100px;
                    position: relative;
                    right: -65px;
                    top: -70px;
                }
            }
            
        }
    }
}
</style>